import React from 'react';
import { WizardContext } from 'react-albus';

interface Props {
  wizard: WizardContext;
}

const WizardProgress: React.FC<Props> = ({ wizard }) => {

  const {
    step: { id: currentStepId },
    steps,
  } = wizard;
  const stepsList = steps.slice(0, steps.length - 1);

  return (
    <div className="subhead">
      <h2>Retirement Checkup</h2>
      <ul className="steps" style={{ display: 'block' }}>
        {stepsList.map(({ id }) => (
          <li key={id} className={`${id === currentStepId && 'selected'}`} />
        ))}
      </ul>
    </div>
  );
};

export default WizardProgress;
